import { createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw } from 'vue-router'
import store from '@/store'
import begin from '@/views/begin';
import home from '@/views/home';
import assistenza from '@/views/assistenza';
import acquisti from '@/views/acquisti';
import shop from '@/views/shop';
import profile from '@/views/profile';
import faq from '@/views/faq';
import chat from '@/views/chat';
import { StorageServices } from '@/services/StorageServices';
import corsi from '@/views/corsi';
import news from '@/views/news';
import cards from '@/views/cards';
import clienti from '@/views/clienti';

const routes: Array<RouteRecordRaw> = [
    ...begin.routes(),
    {
        path: '/',
        component: () => import("@/views/layout.vue"),
        children: [
            ...home.routes(),
            ...assistenza.routes(),
            ...chat.routes(),
            ...acquisti.routes(),
            ...shop.routes(),
            ...profile.routes(),
            ...faq.routes(),
            ...corsi.routes(),
            ...news.routes(),
            ...cards.routes(),
            ...clienti.routes()
        ]
    },
]

// let scrollerSavedPositionList: { routeName: string, top: number}[] = [];
const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior: (to, from, savedPosition) => {
        let scroller = document.querySelector('#app .layoutPageContainer');

        if(savedPosition)
            return savedPosition;
        else
            scroller.scrollTop = 0;

        // if(scroller){
        //     let scrollerSavedPositionIndex = scrollerSavedPositionList.findIndex(x => x.routeName == to.fullPath);
        //     if (scrollerSavedPositionIndex > -1 && savedPosition) {
        //         console.log(scrollerSavedPositionList[scrollerSavedPositionIndex].top);
        //         scroller.scrollTop = scrollerSavedPositionList[scrollerSavedPositionIndex].top;
        //         scrollerSavedPositionList.splice(scrollerSavedPositionIndex, 1);
        //         scrollerSavedPositionList.splice(scrollerSavedPositionList.findIndex(x => x.routeName == from.fullPath), 1);
        //     } else {
        //         scroller.scrollTop = 0;
        //     }
        // }
    }
})


router.beforeEach((to, from, next) => {
    let loginData = StorageServices.getLoginData();
    if(!to.meta.allowAnonymous && !loginData){
        router.push('login' + '?redirect=' + to.fullPath);
        return;
    }

    if(store.state.beforeNavCbs.length == 0)
        next();
    store.state.beforeNavCbs.forEach(x => {
        x(to, from, next);
    });
    store.state.beforeNavCbs = [];
    
    // let scroller = document.querySelector('#app .layoutPageContainer');
    // if(scroller){
    //     scrollerSavedPositionList.push({
    //         routeName: from.fullPath,
    //         top: scroller.scrollTop
    //     })
    // }
})

router.afterEach((to, from) => {
    store.state.afterNavCbs.forEach(x => {
        x(to, from);
    });
    store.state.afterNavCbs = [];
})

export default router
